module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "form-wrap"
  }, [(_vm.user.status == 0 || _vm.user.status == 3) ? _c('div', [_c('div', {
    staticClass: "h2"
  }, [_vm._v("实名认证")]), _vm._v(" "), _c('div', {
    staticClass: "idimgs"
  }, [_c('div', {
    staticClass: "sfz-pic1"
  }, [(_vm.cardPics[0]) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.cardPics[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "picInput0",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadPic0
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sfz-pic2"
  }, [(_vm.cardPics[1]) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.cardPics[1]
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "picInput1",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadPic1
    }
  })])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "name",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "真实姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "cardNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.cardNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cardNum", $$v)
      },
      expression: "formData.cardNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期限",
      "prop": "time_range_str",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "有效期限"
    },
    model: {
      value: (_vm.formData.time_range_str),
      callback: function($$v) {
        _vm.$set(_vm.formData, "time_range_str", $$v)
      },
      expression: "formData.time_range_str"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "签发机关",
      "prop": "office"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "请输入签发机关"
    },
    model: {
      value: (_vm.formData.office),
      callback: function($$v) {
        _vm.$set(_vm.formData, "office", $$v)
      },
      expression: "formData.office"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.status == 0 || _vm.user.status == 3) ? _c('div', {
    staticClass: "tip"
  }, [_c('div', [_c('van-checkbox', {
    staticStyle: {
      "float": "left",
      "transform": "scale(0.6, 0.6)",
      "-webkit-transform": "scale(0.6, 0.6)",
      "-moz-transform": "scale(0.6, 0.6)",
      "-o-transform": "scale(0.6, 0.6)"
    },
    model: {
      value: (_vm.checkXieyi),
      callback: function($$v) {
        _vm.checkXieyi = $$v
      },
      expression: "checkXieyi"
    }
  }), _vm._v("\n              同意"), _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ContentDetail',
        query: {
          id: 10
        }
      }),
      expression: "{name:'ContentDetail',query:{id:10}}"
    }],
    staticClass: "link"
  }, [_vm._v("《实名认证协议》")]), _vm._v("和"), _c('el-link', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ContentDetail',
        query: {
          id: 9
        }
      }),
      expression: "{name:'ContentDetail',query:{id:9}}"
    }],
    staticClass: "link"
  }, [_vm._v("《用户隐私协议》")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "19px"
    }
  }, [_vm._v("\n              并授权平台使用相同姓名及身份证号下的相关用户信息\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.user.status == 0 || _vm.user.status == 3) ? _c('el-row', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交认证\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.status == 0 || _vm.user.status == 3) ? _c('div', {
    staticClass: "tip",
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_vm._v("\n            平台严格保护用户隐私\n          ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.user.status == 1) ? _c('div', [_c('div', {
    staticClass: "cert-status",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "cert-status-content"
  }, [_c('div', {
    staticClass: "cert-status-icon-success"
  }), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title tc"
  }, [_vm._v("认证成功")])])]), _vm._v(" "), (_vm.user.status == 1 || _vm.user.status == 2) ? _c('van-cell-group', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名：",
      "prop": "name",
      "rules": []
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user.user_name) + "\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号：",
      "prop": "cardNum"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user.user_code) + "\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.status == 3 && _vm.user.admin_note) ? _c('van-notice-bar', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n          管理员意见:" + _vm._s(_vm.user.admin_note) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loadding) ? _c('div', {
    staticClass: "mask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "white"
    }
  })], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dbb578c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertPersonApply.vue
// module id = 1503
// module chunks = 0